// extracted by mini-css-extract-plugin
module.exports = {"description":"AvailableTimeForTag_description__3N3eP"};